import React, { useEffect, useRef, useState } from "react";
import { DatePicker, Button, Tag, Space } from 'antd';
import moment from "moment";
import dayjs from 'dayjs';
import { AddwithBlueCircle, Calender, CrosswithRedCircle } from "./AllSvg";
import { CalendarOutlined, CloseOutlined } from '@ant-design/icons';

const { RangePicker } = DatePicker;

const DateRangePickerBackup = ({ startDate, endDate, onChange }) => {
    const [dates, setDates] = useState([null, null]);

    const handleRangeChange = (values) => {
        if (values && values.length === 2) {
            setDates(values);
            onChange(values[0].format("YYYY-MM-DD"), values[1].format("YYYY-MM-DD"));
        } else {
            setDates([null, null]);
            onChange(null, null);
        }
    };

    const setPresetRange = (range) => {
        setDates(range);
        onChange(range[0].format("YYYY-MM-DD"), range[1].format("YYYY-MM-DD"));
    };

    return (
        <div>
            <Space direction="vertical" size={12}>
                <RangePicker
                    value={dates}
                    placeholder={["Select Completion Start Date", "Select Completion End Date"]}
                    onChange={handleRangeChange}
                />
                <Space>
                    <Button onClick={() => setPresetRange([moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")])}>
                        Last Month
                    </Button>
                    <Button onClick={() => setPresetRange([moment().subtract(7, "days"), moment()])}>
                        Last 7 Days
                    </Button>
                    <Button onClick={() => setPresetRange([moment().subtract(30, "days"), moment()])}>
                        Last 30 Days
                    </Button>
                    <Button onClick={() => setPresetRange([moment().startOf("month"), moment().endOf("month")])}>
                        This Month
                    </Button>
                </Space>
            </Space>
        </div>
    );
};

const DateRangePicker = ({ startDate, endDate, onChange }) => {
    const [dates, setDates] = useState([null, null]);

    const handleRangeChange = (values) => {
        if (values && values.length === 2) {
            setDates(values);
            onChange(values[0].format("YYYY-MM-DD"), values[1].format("YYYY-MM-DD"));
        } else {
            setDates([null, null]);
            onChange(null, null);
        }
    };

    const setPresetRange = (range) => {
        setDates(range);
        onChange(range[0].format("YYYY-MM-DD"), range[1].format("YYYY-MM-DD"));
    };

    return (
        <div className="field-cont-div">
            <div className="">
                <Space direction="vertical" size={12}>
                    <RangePicker
                        className=""
                        value={dates}
                        placeholder={["Start Date", "End Date"]}
                        onChange={handleRangeChange}
                    />
                    <div className="preset-buttons">
                        <Button onClick={() => setPresetRange([moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")])}>
                            Last Month
                        </Button>
                        {/* <Button onClick={() => setPresetRange([moment().subtract(7, "days"), moment()])}>
                            Last 7 Days
                        </Button>
                        <Button onClick={() => setPresetRange([moment().subtract(30, "days"), moment()])}>
                            Last 30 Days
                        </Button> */}
                        <Button onClick={() => setPresetRange([moment().startOf("month"), moment().endOf("month")])}>
                            This Month
                        </Button>
                    </div>
                </Space>
            </div>
            <hr className="field-cont-hr" />
        </div>
    );
};


const DateRangeFilter = ({
    startDate,
    endDate,
    onChange,
    showPresets = false,
    className = "",
    placeholder = ["From Date", "To Date"],
}) => {
    const [dates, setDates] = useState([
        startDate ? moment(startDate) : null,
        endDate ? moment(endDate) : null,
    ]);

    useEffect(() => {
        setDates([
            startDate ? moment(startDate) : null,
            endDate ? moment(endDate) : null,
        ]);
    }, [startDate, endDate]);

    const handleRangeChange = (values) => {
        if (values && values.length === 2) {
            setDates(values);
            onChange(values[0].format("YYYY-MM-DD"), values[1].format("YYYY-MM-DD"));
        } else {
            setDates([null, null]);
            onChange(null, null);
        }
    };

    const setPresetRange = (range) => {
        setDates(range);
        onChange(range[0].format("YYYY-MM-DD"), range[1].format("YYYY-MM-DD"));
    };

    return (
        <div className={`date-range-picker-wrapper ${className}`}>
            <RangePicker
                value={dates}
                onChange={handleRangeChange}
                placeholder={placeholder}
                className="attendance-input-field date-field date-field-filter"
                allowClear
            />
            {showPresets && (
                <Space style={{ marginTop: "8px" }}>
                    <Button onClick={() => setPresetRange([
                        moment().subtract(1, "month").startOf("month"),
                        moment().subtract(1, "month").endOf("month")
                    ])}>Last Month</Button>

                    {/* <Button onClick={() => setPresetRange([
                        moment().subtract(7, "days"),
                        moment()
                    ])}>Last 7 Days</Button> */}

                    {/* <Button onClick={() => setPresetRange([
                        moment().subtract(30, "days"),
                        moment()
                    ])}>Last 30 Days</Button> */}

                    <Button onClick={() => setPresetRange([
                        moment().startOf("month"),
                        moment().endOf("month")
                    ])}>This Month</Button>
                </Space>
            )}
        </div>
    );
};



const MultiDateSelect = ({
    value = [],
    onChange,
    placeholder = "Select dates",
    error,
    disabled = false,
    format = "YYYY-MM-DD",
    displayFormat = "DD MMM YYYY",
    style = {}
}) => {
    const [open, setOpen] = useState(false);
    const [selectedDates, setSelectedDates] = useState([]);
    const pickerRef = useRef(null);
    const containerRef = useRef(null);
    const [panelMode, setPanelMode] = useState("date");

    // Initialize from value prop
    useEffect(() => {
        if (value && Array.isArray(value)) {
            const sortedDates = [...value].sort();
            setSelectedDates(sortedDates);
        }
    }, [value]);

    // Close picker when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Toggle date selection
    const toggleDate = (date) => {
        if (!date) return;

        const dateStr = date.format(format);
        let newDates;

        if (selectedDates.includes(dateStr)) {
            // Remove date
            newDates = selectedDates.filter(d => d !== dateStr);
        } else {
            // Add date
            newDates = [...selectedDates, dateStr].sort();
        }

        setSelectedDates(newDates);
        if (onChange) {
            onChange(newDates);
        }
    };

    // Remove a specific date
    const removeDate = (dateToRemove, e) => {
        e.stopPropagation();
        const newDates = selectedDates.filter(date => date !== dateToRemove);
        setSelectedDates(newDates);
        if (onChange) {
            onChange(newDates);
        }
    };

    // Clear all dates
    const clearAllDates = (e) => {
        e.stopPropagation();
        setSelectedDates([]);
        if (onChange) {
            onChange([]);
        }
    };

    // Custom calendar cell render - show selected dates with checkmark
    const dateCellRender = (current) => {
        const dateStr = current.format(format);
        const isSelected = selectedDates.includes(dateStr);

        return (
            <div className="ant-picker-cell-inner">
                {current.date()}
                {isSelected && (
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: '8px',
                        height: '8px',
                        background: '#2576bc',
                        color: 'white',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '10px',
                    }}>
                        {/* ✓ */}
                    </div>
                )}
            </div>
        );
    };
    const cellRender = (current) => {
        const dateStr = current.format(format);
        const isSelected = selectedDates.includes(dateStr);
        /* 🔟 DECADE PANEL */
        if (panelMode === "decade") {
            const startYear = Math.floor(current.year() / 10) * 10;
            return (
                <div className="ant-picker-cell-inner">
                    {startYear} - {startYear + 9}
                    {isSelected && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            width: '8px',
                            height: '8px',
                            background: '#2576bc',
                            color: 'white',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '10px',
                        }}>
                            {/* ✓ */}
                        </div>
                    )}
                </div>
            );
        }

        /* 🗓 YEAR PANEL */
        if (panelMode === "year") {
            return (
                <div className="ant-picker-cell-inner">
                    {current.year()}
                    {isSelected && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            width: '8px',
                            height: '8px',
                            background: '#2576bc',
                            color: 'white',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '10px',
                        }}>
                            {/* ✓ */}
                        </div>
                    )}
                </div>
            );
        }

        /* 📆 MONTH PANEL */
        if (panelMode === "month") {
            return (
                <div className="ant-picker-cell-inner">
                    {current.format("MMM")}
                    {isSelected && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            width: '8px',
                            height: '8px',
                            background: '#2576bc',
                            color: 'white',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '10px',
                        }}>
                            {/* ✓ */}
                        </div>
                    )}
                </div>
            );
        }

        /* 📅 DATE PANEL (default) */
        return (
            <div className="ant-picker-cell-inner">
                {current.date()}
                {isSelected && (
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: '8px',
                        height: '8px',
                        background: '#2576bc',
                        color: 'white',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '10px',
                    }}>
                        {/* ✓ */}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div ref={containerRef} style={{ width: '100%' }}>
            {/* Custom input that looks like React Select */}
            <div
                className={`multi-date-select ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}
                onClick={() => !disabled && setOpen(!open)}
                style={{
                    minHeight: '50px',
                    borderRadius: '10px',
                    border: `1px solid ${error ? '#dc3545' : '#e3e3e3'}`,
                    margin: '10px 0px 00px 0px',
                    color: '#4a4a4a',
                    backgroundColor: disabled ? '#f0f0f0' : '#f7f8fa',
                    padding: '5px 10px',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: '6px',
                    ...style,
                }}
            >
                {selectedDates.length === 0 ? (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        color: '#4a4a4a',
                        opacity: 0.7,
                    }}>
                        {/* <CalendarOutlined /> */}
                        <Calender />
                        <span>{placeholder}</span>
                    </div>
                ) : (
                    <>
                        {selectedDates.map((date, index) => (
                            <div
                                key={index}
                                className="color-tab-blue"
                                style={{
                                    // color: '#f2f2f3',
                                    // background: '#2576bc30',
                                    // border: '1px solid #2576bc',
                                    borderRadius: '4px',
                                    padding: '4px 8px',
                                    fontSize: '14px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                }}
                            >
                                <span>{dayjs(date).format(displayFormat)}</span>
                                {!disabled && (
                                    <CloseOutlined
                                        onClick={(e) => removeDate(date, e)}
                                        style={{
                                            fontSize: '12px',
                                            color: '#2576bc',
                                            cursor: 'pointer',
                                        }}
                                    />
                                )}
                            </div>
                        ))}
                        {!disabled && selectedDates.length > 0 && (
                            <CloseOutlined
                                onClick={clearAllDates}
                                style={{
                                    marginLeft: 'auto',
                                    fontSize: '14px',
                                    color: '#6c757d',
                                    cursor: 'pointer',
                                    padding: '4px',
                                }}
                            />
                        )}
                    </>
                )}
            </div>

            {/* Hidden DatePicker that provides the calendar */}
            <div style={{ position: 'absolute', zIndex: -1, opacity: 0 }}>
                <DatePicker
                    ref={pickerRef}
                    open={open}
                    mode={panelMode}
                    onOpenChange={setOpen}
                    // onChange={toggleDate}
                    onPanelChange={(date, mode) => {
                        setPanelMode(mode);     // ← THIS IS CRITICAL
                    }}
                    onChange={(date) => {
                        setPanelMode("date");  // ← reset after selection
                        toggleDate(date);
                    }}
                    value={null}
                    getPopupContainer={() => containerRef.current}
                    popupStyle={{
                        marginTop: '8px',
                        borderRadius: '10px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    }}
                    // cellRender={dateCellRender}
                    cellRender={cellRender}
                />
            </div>

            {error && (
                <div style={{
                    color: '#dc3545',
                    fontSize: '12px',
                    marginTop: '4px',
                    marginLeft: '4px',
                }}>
                    {error}
                </div>
            )}
        </div>
    );
};

const MultiDateSelectBackupLatest = ({
    value = [],
    onChange,
    placeholder = "Select dates",
    error,
    disabled = false,
    format = "YYYY-MM-DD",
    displayFormat = "DD MMM YYYY",
    style = {},
    disableDate,
    Disabledtitle
}) => {
    const [open, setOpen] = useState(false);
    const [selectedDates, setSelectedDates] = useState([]);
    const pickerRef = useRef(null);
    const containerRef = useRef(null);
    const [panelMode, setPanelMode] = useState("date");

    // Initialize from value prop
    useEffect(() => {
        if (value && Array.isArray(value)) {
            const sortedDates = [...value].sort();
            setSelectedDates(sortedDates);
        }
    }, [value]);

    // Close picker when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Toggle date selection
    // const toggleDate = (date) => {
    //     if (!date) return;
    //     if (disableDate && disableDate(date)) return;
    //     const dateStr = date.format(format);
    //     let newDates;

    //     if (selectedDates.includes(dateStr)) {
    //         // Remove date
    //         newDates = selectedDates.filter(d => d !== dateStr);
    //     } else {
    //         // Add date
    //         newDates = [...selectedDates, dateStr].sort();
    //     }

    //     setSelectedDates(newDates);
    //     if (onChange) {
    //         onChange(newDates);
    //     }
    // };
    const toggleDate = (date) => {
        if (!date) return;

        const result = disableDate ? disableDate(date) : false;
        const isDisabled = typeof result === "object" ? result.disabled : result;

        if (isDisabled) return;

        const dateStr = date.format(format);

        let newDates;
        if (selectedDates.includes(dateStr)) {
            newDates = selectedDates.filter(d => d !== dateStr);
        } else {
            newDates = [...selectedDates, dateStr].sort();
        }

        setSelectedDates(newDates);
        onChange && onChange(newDates);
    };

    // Remove a specific date
    const removeDate = (dateToRemove, e) => {
        e.stopPropagation();
        const newDates = selectedDates.filter(date => date !== dateToRemove);
        setSelectedDates(newDates);
        if (onChange) {
            onChange(newDates);
        }
    };

    // Clear all dates
    const clearAllDates = (e) => {
        e.stopPropagation();
        setSelectedDates([]);
        if (onChange) {
            onChange([]);
        }
    };

    // Custom calendar cell render - show selected dates with checkmark
    const dateCellRender = (current) => {
        const dateStr = current.format(format);
        const isSelected = selectedDates.includes(dateStr);

        return (
            <div className="ant-picker-cell-inner">
                {current.date()}
                {isSelected && (
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: '8px',
                        height: '8px',
                        background: '#2576bc',
                        color: 'white',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '10px',
                    }}>
                        {/* ✓ */}
                    </div>
                )}
            </div>
        );
    };
    const cellRender = (current) => {
        const dateStr = current.format(format);
        const isSelected = selectedDates.includes(dateStr);
        let reason = "";
        let isDisabled = false;
        /* 🔟 DECADE PANEL */
        if (panelMode === "decade") {
            const startYear = Math.floor(current.year() / 10) * 10;
            return (
                <div className="ant-picker-cell-inner">
                    {startYear} - {startYear + 9}
                    {isSelected && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            width: '8px',
                            height: '8px',
                            background: '#2576bc',
                            color: 'white',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '10px',
                        }}>
                            {/* ✓ */}
                        </div>
                    )}
                </div>
            );
        }

        /* 🗓 YEAR PANEL */
        if (panelMode === "year") {
            return (
                <div className="ant-picker-cell-inner">
                    {current.year()}
                    {isSelected && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            width: '8px',
                            height: '8px',
                            background: '#2576bc',
                            color: 'white',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '10px',
                        }}>
                            {/* ✓ */}
                        </div>
                    )}
                </div>
            );
        }

        /* 📆 MONTH PANEL */
        if (panelMode === "month") {
            return (
                <div className="ant-picker-cell-inner">
                    {current.format("MMM")}
                    {isSelected && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            width: '8px',
                            height: '8px',
                            background: '#2576bc',
                            color: 'white',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '10px',
                        }}>
                            {/* ✓ */}
                        </div>
                    )}
                </div>
            );
        }

        if (disableDate) {
            const result = disableDate(current);
            if (typeof result === "object") {
                isDisabled = result.disabled;
                reason = result.reason;
            } else {
                isDisabled = result;
            }
        }

        /* 📅 DATE PANEL (default) */
        return (
            <div className="ant-picker-cell-inner"
                title={isDisabled ? reason : ""}
                style={{
                    position: "relative",
                    opacity: isDisabled ? 0.5 : 1,
                    cursor: isDisabled ? "not-allowed" : "pointer"
                }}
            >
                {current.date()}
                {isSelected && (
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: '8px',
                        height: '8px',
                        background: '#2576bc',
                        color: 'white',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '10px',
                    }}>
                        {/* ✓ */}

                        {/*  Disabled overlay (optional visual improvement) */}
                        {isDisabled && (
                            <div style={{
                                position: "absolute",
                                inset: 0,
                                background: "rgba(0,0,0,0.05)",
                                borderRadius: "4px"
                            }} />
                        )}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div ref={containerRef} style={{ width: '100%' }} title={
            Disabledtitle
        }>
            {/* Custom input that looks like React Select */}
            <div
                className={`multi-date-select ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}
                onClick={() => !disabled && setOpen(!open)}

                style={{
                    minHeight: '50px',
                    borderRadius: '10px',
                    border: `1px solid ${error ? '#dc3545' : '#e3e3e3'}`,
                    margin: '10px 0px 00px 0px',
                    color: '#4a4a4a',
                    backgroundColor: disabled ? '#f0f0f0' : '#f7f8fa',
                    padding: '5px 10px',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: '6px',
                    ...style,
                }}
            >
                {selectedDates.length === 0 ? (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        color: '#4a4a4a',
                        opacity: 0.7,
                    }}>
                        {/* <CalendarOutlined /> */}
                        <Calender />
                        <span>{placeholder}</span>
                    </div>
                ) : (
                    <>
                        {selectedDates.map((date, index) => (
                            <div
                                key={index}
                                className="color-tab-blue"
                                style={{
                                    // color: '#f2f2f3',
                                    // background: '#2576bc30',
                                    // border: '1px solid #2576bc',
                                    borderRadius: '4px',
                                    padding: '4px 8px',
                                    fontSize: '14px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                }}
                            >
                                <span>{dayjs(date).format(displayFormat)}</span>
                                {!disabled && (
                                    <CloseOutlined
                                        onClick={(e) => removeDate(date, e)}
                                        style={{
                                            fontSize: '12px',
                                            color: '#2576bc',
                                            cursor: 'pointer',
                                        }}
                                    />
                                )}
                            </div>
                        ))}
                        {!disabled && selectedDates.length > 0 && (
                            <CloseOutlined
                                onClick={clearAllDates}
                                style={{
                                    marginLeft: 'auto',
                                    fontSize: '14px',
                                    color: '#6c757d',
                                    cursor: 'pointer',
                                    padding: '4px',
                                }}
                            />
                        )}
                    </>
                )}
            </div>

            {/* Hidden DatePicker that provides the calendar */}
            <div style={{ position: 'absolute', zIndex: -1, opacity: 0 }}>
                <DatePicker
                    ref={pickerRef}
                    open={open}
                    mode={panelMode}
                    // disabledDate={(current) => {
                    //     if (!disableDate) return false;
                    //     return disableDate(current);
                    // }}
                    disabledDate={(current) => {
                        if (!disableDate) return false;
                        const result = disableDate(current);
                        return typeof result === "object" ? result.disabled : result;
                    }}
                    onOpenChange={setOpen}
                    // onChange={toggleDate}
                    onPanelChange={(date, mode) => {
                        setPanelMode(mode);     // ← THIS IS CRITICAL
                    }}
                    onChange={(date) => {
                        setPanelMode("date");  // ← reset after selection
                        toggleDate(date);
                    }}
                    value={null}
                    getPopupContainer={() => containerRef.current}
                    popupStyle={{
                        marginTop: '8px',
                        borderRadius: '10px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    }}
                    // cellRender={dateCellRender}
                    cellRender={cellRender}
                />
            </div>

            {error && (
                <div style={{
                    color: '#dc3545',
                    fontSize: '12px',
                    marginTop: '4px',
                    marginLeft: '4px',
                }}>
                    {error}
                </div>
            )}
        </div>
    );
};

const MultiDateSelectNewTrialBackup = ({
    value = [],
    onChange,
    placeholder = "Select dates",
    error,
    disabled = false,
    format = "YYYY-MM-DD",
    displayFormat = "DD MMM YYYY",
    style = {},
    disabledDates = [],
    minDate = null,
    maxDate = null,
    disabledDateRanges = []
}) => {
    const [open, setOpen] = useState(false);
    const [selectedDates, setSelectedDates] = useState([]);
    const pickerRef = useRef(null);
    const containerRef = useRef(null);
    const [panelMode, setPanelMode] = useState("date");

    const toDayjs = (date) => {
        if (!date) return null;
        if (dayjs.isDayjs(date)) return date;
        return dayjs(date);
    };

    // Initialize from value prop
    useEffect(() => {
        if (value && Array.isArray(value)) {
            const sortedDates = [...value].sort();
            setSelectedDates(sortedDates);
        }
    }, [value]);

    // Close picker when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Check if a date is disabled
    const isDateDisabled = (date) => {
        if (!date) return true;

        const dateStr = date.format(format);

        // Check if in disabledDates list
        if (disabledDates.includes(dateStr)) {
            return true;
        }

        // Check if in disabled date ranges
        if (disabledDateRanges && disabledDateRanges.length > 0) {
            for (const range of disabledDateRanges) {
                const rangeStart = toDayjs(range.start);
                const rangeEnd = toDayjs(range.end);
                if (rangeStart && rangeEnd && date.isBetween(rangeStart, rangeEnd, 'day', '[]')) {
                    return true;
                }
            }
        }

        // Check min/max constraints
        if (minDate) {
            const min = toDayjs(minDate);
            if (min && date.isBefore(min, 'day')) {
                return true;
            }
        }

        if (maxDate) {
            const max = toDayjs(maxDate);
            if (max && date.isAfter(max, 'day')) {
                return true;
            }
        }

        return false;
    };

    // Toggle date selection
    const toggleDate = (date) => {
        if (!date || isDateDisabled(date)) return;

        const dateStr = date.format(format);
        let newDates;

        if (selectedDates.includes(dateStr)) {
            // Remove date
            newDates = selectedDates.filter(d => d !== dateStr);
        } else {
            // Add date
            newDates = [...selectedDates, dateStr].sort();
        }

        setSelectedDates(newDates);
        if (onChange) {
            onChange(newDates);
        }
    };

    // Remove a specific date
    const removeDate = (dateToRemove, e) => {
        e.stopPropagation();
        const newDates = selectedDates.filter(date => date !== dateToRemove);
        setSelectedDates(newDates);
        if (onChange) {
            onChange(newDates);
        }
    };

    // Clear all dates
    const clearAllDates = (e) => {
        e.stopPropagation();
        setSelectedDates([]);
        if (onChange) {
            onChange([]);
        }
    };

    const cellRender = (current) => {
        const dateStr = current.format(format);
        const isSelected = selectedDates.includes(dateStr);
        const isDisabled = isDateDisabled(current);

        const cellStyle = {
            position: 'relative',
            opacity: isDisabled ? 0.3 : 1,
            cursor: isDisabled ? 'not-allowed' : 'pointer',
        };

        /* 🔟 DECADE PANEL */
        if (panelMode === "decade") {
            const startYear = Math.floor(current.year() / 10) * 10;
            return (
                <div className="ant-picker-cell-inner" style={cellStyle}>
                    {startYear} - {startYear + 9}
                    {isSelected && !isDisabled && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            width: '8px',
                            height: '8px',
                            background: '#2576bc',
                            color: 'white',
                            borderRadius: '50%',
                            // display: 'flex',
                            // alignItems: 'center',
                            // justifyContent: 'center',
                            // fontSize: '10px',
                        }}>
                            {/* ✓ */}
                        </div>
                    )}
                </div>
            );
        }

        /* 🗓 YEAR PANEL */
        if (panelMode === "year") {
            return (
                <div className="ant-picker-cell-inner" style={cellStyle}>
                    {current.year()}
                    {isSelected && !isDisabled && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            width: '8px',
                            height: '8px',
                            background: '#2576bc',
                            color: 'white',
                            borderRadius: '50%',
                            // display: 'flex',
                            // alignItems: 'center',
                            // justifyContent: 'center',
                            // fontSize: '10px',
                        }}>
                            {/* ✓ */}
                        </div>
                    )}
                </div>
            );
        }

        /* 📆 MONTH PANEL */
        if (panelMode === "month") {
            return (
                <div className="ant-picker-cell-inner" style={cellStyle}>
                    {current.format("MMM")}
                    {isSelected && !isDisabled && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            width: '8px',
                            height: '8px',
                            background: '#2576bc',
                            color: 'white',
                            borderRadius: '50%',
                            // display: 'flex',
                            // alignItems: 'center',
                            // justifyContent: 'center',
                            // fontSize: '10px',
                        }}>
                            {/* ✓ */}
                        </div>
                    )}
                </div>
            );
        }

        /* 📅 DATE PANEL (default) */
        return (
            <div className="ant-picker-cell-inner" style={cellStyle}>
                {current.date()}
                {isSelected && !isDisabled && (
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: '8px',
                        height: '8px',
                        background: '#2576bc',
                        color: 'white',
                        borderRadius: '50%',
                        // display: 'flex',
                        // alignItems: 'center',
                        // justifyContent: 'center',
                        // fontSize: '10px',
                    }}>
                        {/* ✓ */}
                    </div>
                )}
            </div>
        );
    };

    // Disabled date function for DatePicker
    const disabledDate = (current) => {
        return isDateDisabled(current);
    };

    return (
        <div ref={containerRef} style={{ width: '100%' }}>
            {/* Custom input that looks like React Select */}
            <div
                className={`multi-date-select ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}
                onClick={() => !disabled && setOpen(!open)}
                style={{
                    minHeight: '50px',
                    borderRadius: '10px',
                    border: `1px solid ${error ? '#dc3545' : '#e3e3e3'}`,
                    margin: '10px 0px 00px 0px',
                    color: '#4a4a4a',
                    backgroundColor: disabled ? '#f0f0f0' : '#f7f8fa',
                    padding: '5px 10px',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: '6px',
                    ...style,
                }}
            >
                {selectedDates.length === 0 ? (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        color: '#4a4a4a',
                        opacity: 0.7,
                    }}>
                        {/* <CalendarOutlined /> */}
                        <Calender />
                        <span>{placeholder}</span>
                    </div>
                ) : (
                    <>
                        {selectedDates.map((date, index) => (
                            <div
                                key={index}
                                className="color-tab-blue"
                                style={{
                                    // color: '#f2f2f3',
                                    // background: '#2576bc30',
                                    // border: '1px solid #2576bc',
                                    borderRadius: '4px',
                                    padding: '4px 8px',
                                    fontSize: '14px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                }}
                            >
                                <span>{dayjs(date).format(displayFormat)}</span>
                                {!disabled && (
                                    <CloseOutlined
                                        onClick={(e) => removeDate(date, e)}
                                        style={{
                                            fontSize: '12px',
                                            color: '#2576bc',
                                            cursor: 'pointer',
                                        }}
                                    />
                                )}
                            </div>
                        ))}
                        {!disabled && selectedDates.length > 0 && (
                            <CloseOutlined
                                onClick={clearAllDates}
                                style={{
                                    marginLeft: 'auto',
                                    fontSize: '14px',
                                    color: '#6c757d',
                                    cursor: 'pointer',
                                    padding: '4px',
                                }}
                            />
                        )}
                    </>
                )}
            </div>

            {/* Hidden DatePicker that provides the calendar */}
            <div style={{ position: 'absolute', zIndex: -1, opacity: 0 }}>
                <DatePicker
                    ref={pickerRef}
                    open={open}
                    mode={panelMode}
                    onOpenChange={setOpen}
                    // onChange={toggleDate}
                    onPanelChange={(date, mode) => {
                        setPanelMode(mode);     // ← THIS IS CRITICAL
                    }}
                    onChange={(date) => {
                        setPanelMode("date");  // ← reset after selection
                        toggleDate(date);
                    }}
                    value={null}
                    getPopupContainer={() => containerRef.current}
                    popupStyle={{
                        marginTop: '8px',
                        borderRadius: '10px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    }}
                    cellRender={cellRender}
                />
            </div>

            {error && (
                <div style={{
                    color: '#dc3545',
                    fontSize: '12px',
                    marginTop: '4px',
                    marginLeft: '4px',
                }}>
                    {error}
                </div>
            )}
        </div>
    );
};


const SingleMonthYearSelect = ({
    value,
    onChange,
    placeholder = "Select Month",
    disabled = false,
    error,
    style = {},
    selectedMonthSet,
}) => {
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);
    const [panelMode, setPanelMode] = useState("month");

    // close on outside click
    useEffect(() => {
        const handler = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    // MONTH CELL RENDER (isSelected like MultiDateSelect)
    const monthCellRenderbackup = (current) => {
        const monthStr = current.format("YYYY-MM");

        const isHighlighted =
            selectedMonthSet instanceof Set &&
            selectedMonthSet.has(monthStr);

        return (
            <div
                className="ant-picker-cell-inners"
                style={{ position: "relative" }}
            >
                {current.format("MMM")}

                {isHighlighted && (
                    <div
                        style={{
                            position: "absolute",
                            top: 4,
                            right: 4,
                            width: 10,
                            height: 8,
                            borderRadius: "50%",
                            background: "#2576bc",
                        }}
                    />
                )}
            </div>
        );
    };

    const monthCellRender = (current) => {

        // DECADE PANEL (highest level)
        if (panelMode === "decade") {
            const startYear = Math.floor(current.year() / 10) * 10;
            return (
                <div className="ant-picker-cell-inner">
                    {startYear} - {startYear + 9}
                </div>
            );
        }

        // YEAR PANEL
        if (panelMode === "year") {
            return (
                <div className="ant-picker-cell-inner">
                    {current.year()}
                </div>
            );
        }

        // MONTH PANEL
        const monthStr = current.format("YYYY-MM");

        const isHighlighted =
            selectedMonthSet instanceof Set &&
            selectedMonthSet.has(monthStr);

        return (
            <div
                className="ant-picker-cell-inner"
                style={{ position: "relative" }}
            >
                {current.format("MMM")}
                {/* check is seleceted color scheme */}
                {isHighlighted && (
                    <div
                        style={{
                            position: "absolute",
                            top: 4,
                            right: 4,
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            background: "#2576bc",
                        }}
                    />
                )}
            </div>
        );
    };



    return (
        <div ref={containerRef} >
            <div
                className={`multi-date-select ${error ? "error" : ""} ${disabled ? "disabled" : ""}`}
                onClick={() => !disabled && setOpen(!open)}
                style={{
                    // minHeight: "50px",
                    borderRadius: "10px",
                    border: `1px solid ${error ? "#dc3545" : "#e3e3e3"}`,
                    backgroundColor: disabled ? "#f0f0f0" : "#f7f8fa",
                    padding: "10px 10px",
                    cursor: disabled ? "not-allowed" : "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    ...style,
                }}
            >
                {value ? (
                    <>
                        <Calender />
                        <span>{dayjs(value).format("MMMM YYYY")}</span>
                    </>
                ) : (
                    <>
                        <Calender />
                        <span style={{ opacity: 0.6 }}>{placeholder}</span>
                    </>
                )}
            </div>

            {/* Hidden Month Picker */}
            <div style={{ position: "absolute", zIndex: -1, opacity: 0 }}>
                <DatePicker
                    open={open}
                    picker="month"
                    mode={panelMode}
                    value={value ? dayjs(value) : null}
                    onPanelChange={(date, mode) => {
                        setPanelMode(mode);
                    }}
                    onChange={(date) => {
                        setPanelMode("month");   // reset after selection
                        setOpen(false);
                        onChange?.(date ? date.format("YYYY-MM") : null);
                    }}
                    getPopupContainer={() => containerRef.current}
                    placement="bottomLeft"
                    popupStyle={{
                        marginTop: 0,
                        borderRadius: 10,
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    }}
                    cellRender={monthCellRender}
                />
            </div>

            {error && (
                <div style={{ color: "#dc3545", fontSize: 12, marginTop: 4 }}>
                    {error}
                </div>
            )}
        </div>
    );
};



const formatToYYYYMM = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
};

const getPreviousMonth = (yyyyMM) => {
    if (!yyyyMM) return "";
    const [year, month] = yyyyMM.split("-").map(Number);
    const d = new Date(year, month - 2, 1); // minus 1 month
    return formatToYYYYMM(d);
};


export { DateRangePicker, DateRangeFilter, MultiDateSelect, MultiDateSelectBackupLatest, SingleMonthYearSelect, formatToYYYYMM, getPreviousMonth };